/**
 * TCKN (T.C. Kimlik Numarası) doğrulama — 11 haneli, NVI algoritması.
 *
 * Kurallar:
 * - 11 hane
 * - İlk hane 0 olamaz
 * - 10. hane: ((d1+d3+d5+d7+d9) * 7 - (d2+d4+d6+d8)) mod 10
 * - 11. hane: (d1+...+d10) mod 10
 */
export function isValidTCKN(tckn: string): boolean {
  if (!/^[1-9]\d{10}$/.test(tckn)) return false;

  const digits = tckn.split('').map(Number);
  const oddSum = digits[0]! + digits[2]! + digits[4]! + digits[6]! + digits[8]!;
  const evenSum = digits[1]! + digits[3]! + digits[5]! + digits[7]!;

  const tenthDigit = (oddSum * 7 - evenSum) % 10;
  if (tenthDigit !== digits[9]) return false;

  const sumFirstTen = digits.slice(0, 10).reduce((acc, d) => acc + d, 0);
  return sumFirstTen % 10 === digits[10];
}

/**
 * TCKN'yi maskeleme — log/UI için (son 3 hane görünür).
 * @example maskTCKN("12345678901") === "********901"
 */
export function maskTCKN(tckn: string): string {
  if (tckn.length !== 11) return tckn;
  return '*'.repeat(8) + tckn.slice(8);
}

/**
 * TR-H6 — Tax number (TCKN/VKN ayırt etmeden) için log-safe maske.
 * Uzunluğa göre TCKN/VKN ayrımı yapar ve `123*****901` formatında döner
 * (ilk 3 hane + maske + son 3 hane). Audit log'larda plaintext TCKN/VKN
 * yer almamalı — bu helper yalnızca masked değer ve length flag taşır.
 *
 * @example maskTaxNumber("12345678901") === "123*****901"
 * @example maskTaxNumber("1234567890")  === "123*****890"
 * @example maskTaxNumber("xx")          === "***"
 */
export function maskTaxNumber(value: string | null | undefined): string {
  if (!value || typeof value !== 'string') return '***';
  if (value.length === 11) return `${value.slice(0, 3)}*****${value.slice(-3)}`;
  if (value.length === 10) return `${value.slice(0, 3)}*****${value.slice(-3)}`;
  return '***';
}
